import { __decorate, __metadata } from "tslib";
import { I18nThemed } from 'interfaces/mixins';
import { theme } from '@dojo/framework/core/mixins/Themed';
import { v } from '@dojo/framework/core/vdom';
import { beforeProperties } from '@dojo/framework/core/decorators/beforeProperties';
import css from '../css/prometric.m.css';
let CountdownTimer = class CountdownTimer extends I18nThemed {
    _propsInited = false;
    render() {
        const { countdown } = this.properties;
        const isNeg = countdown && countdown.startsWith('-');
        const classes = isNeg ? [this.theme(css.timerNegative)] : [];
        return v('span', { classes }, [v('i', { classes: ['far', 'fa-clock', css.actionIcon] }), countdown]);
    }
    stateProperties(properties) {
        const { quizstore } = properties;
        const { get, path } = quizstore;
        if (!this._propsInited) {
            const paths = [['countdown']];
            const invalidatePaths = paths.map((path) => quizstore.path(path.join('/')));
            const handle = quizstore.onChange(invalidatePaths, () => this.invalidate());
            this.own({
                destroy: () => {
                    handle.remove();
                }
            });
            this._propsInited = true;
        }
        properties.countdown = get(path('countdown'));
        return properties;
    }
};
__decorate([
    beforeProperties(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Object)
], CountdownTimer.prototype, "stateProperties", null);
CountdownTimer = __decorate([
    theme(css)
], CountdownTimer);
export { CountdownTimer };
